import React from 'react'
import Header from "../../../components/MainHeader/MainHeader"
import Hero from "../../../components/Hero/Hero"
import Programs from "../../../components/Programs/Programs"
import Academy from "../../../components/Academy/Academy"
import Goals from "../../../components/Goals/Goals"
import Journey from "../../../components/Journey/Journey"
import Testimonials from "../../../components/Testimonial/Testimonials"
import Contact from "../../../components/Contact/Contact"
import Newsletter from "../../../components/NewsLetter/Newsletter"
import Footer from "../../../components/Footer/Footer"

const HomePage = () => {
    return (
        <div>
            <Header />
            <Hero />
            <Programs />
            <Academy />
            <Goals />
            <Journey />
            <Testimonials />
            <Contact />
            <Newsletter />
            <Footer />
        </div>
    )
}

export default HomePage
